module.exports = __webpack_public_path__ + "static/media/nosotros02.a2b64051.jpg";